<template>
  <div
    class="btn-toolbar"
    role="toolbar"
    aria-label="Toolbar with button groups"
    style="width: 100%!important;"
  >
    <div class="btn-group btn-group-toggle btn-block" role="group">
      &nbsp;
      <button
        type="button"
        class="btn btn-candle"
        v-if="oneMonth"
        v-on:click="_pickedDateInterval('1M')"
        v-bind:class="[initPickedDateInterval === '1M' ? 'active' : '']"
      >
        1M
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="threeMonths"
        v-on:click="_pickedDateInterval('3M')"
        v-bind:class="[initPickedDateInterval === '3M' ? 'active' : '']"
      >
        3M
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="sixMonths"
        v-on:click="_pickedDateInterval('6M')"
        v-bind:class="[initPickedDateInterval === '6M' ? 'active' : '']"
      >
        6M
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="nineMonths"
        v-on:click="_pickedDateInterval('9M')"
        v-bind:class="[initPickedDateInterval === '9M' ? 'active' : '']"
      >
        9M
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="oneYear"
        v-on:click="_pickedDateInterval('1Y')"
        v-bind:class="[initPickedDateInterval === '1Y' ? 'active' : '']"
      >
        1Y
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="twoYears"
        v-on:click="_pickedDateInterval('2Y')"
        v-bind:class="[initPickedDateInterval === '2Y' ? 'active' : '']"
      >
        2Y
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="threeYears"
        v-on:click="_pickedDateInterval('3Y')"
        v-bind:class="[initPickedDateInterval === '3Y' ? 'active' : '']"
      >
        3Y
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="fiveYears"
        v-on:click="_pickedDateInterval('5Y')"
        v-bind:class="[initPickedDateInterval === '5Y' ? 'active' : '']"
      >
        5Y
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="tenYears"
        v-on:click="_pickedDateInterval('10Y')"
        v-bind:class="[initPickedDateInterval === '10Y' ? 'active' : '']"
      >
        10Y
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-if="twentyYears"
        v-on:click="_pickedDateInterval('20Y')"
        v-bind:class="[initPickedDateInterval === '20Y' ? 'active' : '']"
      >
        20Y
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntervalsIndep",
  props: {
    initPickedDateInterval: { required: true },
    oneMonth: { default: true },
    threeMonths: { default: true },
    sixMonths: { default: true },
    nineMonths: { default: true },
    oneYear: { default: true },
    twoYears: { default: true },
    threeYears: { default: true },
    fiveYears: { default: true },
    tenYears: { default: true },
    twentyYears: { default: true }
  },
  methods: {
    _pickedDateInterval(interval) {
      this.$emit("eventOnChangeInterval", interval);
    }
  }
};
</script>
